"use client";

import type { FlexProps as _FlexProps, SpacerProps as _FlexSpacerProps } from "@chakra-ui/react";
import { forwardRef, Flex as _Flex, Spacer as _Spacer } from "@chakra-ui/react";
import { removePropsFromHTML } from "../../../utils/removeProps";

export interface FlexProps extends _FlexProps {}

export interface FlexSpacerProps extends _FlexSpacerProps {}

export const Flex = forwardRef<FlexProps, "div">(({ ...props }, ref) => (
    <_Flex ref={ref} {...removePropsFromHTML(props)} />
));

export const FlexSpacer = ({ ...props }: FlexSpacerProps) => (
    <_Spacer {...removePropsFromHTML(props)} />
);
